var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIpld(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 81,
    viewBox: "0 0 134 81",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logotype_IPLD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.638 58.696V21.994c0-1.25-.667-2.405-1.75-3.03L37.103.613a3.499 3.499 0 0 0-3.498 0L1.82 18.963a3.498 3.498 0 0 0-1.75 3.03v36.703c0 1.25.667 2.405 1.75 3.03l31.785 18.35a3.499 3.499 0 0 0 3.498 0l31.785-18.35a3.498 3.498 0 0 0 1.75-3.03z",
    fill: "#1D74F2"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.754 4.692)",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6 70.24L1.23 52.455V19.034L31.6 1.066l.043.024L61.97 18.317v34.139l-.043.025L31.6 70.239zM1.402 52.356L31.6 70.039l30.198-17.682v-33.94L31.6 1.266 1.402 19.132v33.225z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.909 10.953h1.382v59.186h-1.382z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.6,
    cy: 11.068,
    r: 2.175
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.939 27.127l-6.642-4.196v-8.048h1.382v7.287l5.998 3.789z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.346 32.284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.784 22.438L.046 21.27l22.73-14.36V3.77h1.383v3.903z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.468,
    cy: 2.308,
    r: 2.175
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.357 31.103h1.382v16.121h-1.382zM31.086 43.632L14.26 34.383V27.01h1.382v6.58l16.139 8.848z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.951,
    cy: 26.396,
    r: 2.175
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.988,
    cy: 16.52,
    r: 2.175
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.158 22.149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.308 3.784v3.143L.124 15.887c.011.533.03 1.068.049 1.603L15.69 7.688V3.785h-1.382z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.999,
    cy: 2.323,
    r: 2.175
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.08 31.103l6.641-4.195v-8.049H37.34v7.287l-5.998 3.789z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.03,
    cy: 18.859,
    r: 2.175
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.657,
    cy: 30.397,
    r: 2.175
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.966 30.917h1.382v8.687h-1.382z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.194 34.537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.031 20.367l.739-1.168L3.038 6.804V3.662H1.656v3.904z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.347,
    cy: 2.201,
    r: 2.175
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.78 35.652h1.238v11.171H16.78z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.6,
    cy: 69.912,
    r: 1.213
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 18.02)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.23,
    cy: 34.437,
    r: 1.213
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.23,
    cy: 1.351,
    r: 1.213
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.627 18.02)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.343,
    cy: 34.359,
    r: 1.213
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.343,
    cy: 1.273,
    r: 1.213
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 31.599,
    cy: 1.393,
    r: 1.213
  })), /*#__PURE__*/React.createElement("path", {
    d: "M83.893 24.094v31.21h-3.478v-31.21zm10.387 0c4.905 0 7 2.898 7 7.624v3.745c0 4.949-2.318 7.535-7.267 7.535h-3.076v12.305h-3.478v-31.21h6.822zm-.267 15.783c2.586 0 3.835-1.204 3.835-4.191v-4.147c0-2.853-1.026-4.28-3.567-4.28h-3.344v12.618h3.076zm10.121 15.426v-31.21h3.478v28.045h8.917v3.165h-12.395zm22.337-31.209c4.86 0 7.09 2.942 7.09 7.758V47.59c0 4.77-2.23 7.713-7.09 7.713h-7.312v-31.21h7.312zm-.044 28.044c2.497 0 3.7-1.56 3.7-4.414V31.673c0-2.853-1.203-4.414-3.745-4.414h-3.745v24.878h3.79z",
    fill: "#1D74F2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpld);
export default __webpack_public_path__ + "static/media/ipld.c2e6094fbcd21952d9a1019f204a629e.svg";
export { ForwardRef as ReactComponent };